import React, { createContext, useContext, useState } from 'react';

const SubmissionLimitContext = createContext();

export const SubmissionLimitProvider = ({ children }) => {
    const [limit, setLimit] = useState(null);

    const handleChangeLimitNumber = (e) => {
        setLimit(e.target.value);
    };

    const clearLimit = () => {
        setLimit(null);
    };

    return (
        <SubmissionLimitContext.Provider value={{ limit, handleChangeLimitNumber, clearLimit }}>
            {children}
        </SubmissionLimitContext.Provider>
    );
};

export const useSubmissionLimit = () => {
    return useContext(SubmissionLimitContext);
};
